//write a function that checks if window is not undefined and if it is, it will return the window.location.origin
export const getOrigin = (): string => {
  return process.env.NEXT_PUBLIC_BASEURL ?? 'https://gubi.com'
}
